import React, { useContext, useState, useEffect } from "react";
import { TranslationContext } from "../../commons/context/TranslationContext";


export const Translation = ({stringId, placeholder=[]}) => {
    const { translations } = useContext(TranslationContext);
    const [state, setState] = useState('');

    useEffect(() => {
        let output = translations[stringId] || '';
        placeholder.forEach(([holder, value]) => {
            output = output.replace(holder, value)
        });
        setState(output);
        
    }, [translations, placeholder])
    
    return (<React.Fragment>{state}</React.Fragment>);
};

export const useTranslation = ({stringId}) => {
    const { translations } = useContext(TranslationContext);
    return translations[stringId] || "";
}



// WEBPACK FOOTER //
// ./src/components/scrub/Translation.js